module.exports = __webpack_public_path__ + "img/ibu-canggih.d44133d2.png";